import {useCallback} from 'react';
import {networkStore, NodeId, useNetworkStore} from './networkStore';

// -------------------- Selectors --------------------

export const useNetworkLinks = () => useNetworkStore(state => state.links);
export const useNetworkNodes = () => useNetworkStore(state => state.nodes);
export const useNetworkOwnership = () => useNetworkStore(state => state.ownership);
export const usePlacedPlayerIds = () => useNetworkStore(state => state.getPlacedPlayerIds());
export const usePlayerByNodeId = (nodeId: NodeId) =>
    useNetworkStore(state => state.getPlayerByNodeId(nodeId));

// -------------------- Raw actions --------------------

export const useMoveNode = () => useNetworkStore(state => state.moveNode);
export const useAddNode = () => useNetworkStore(state => state.addNode);
export const useDeleteNode = () => useNetworkStore(state => state.deleteNode);
export const useSetNodeOwner = () => useNetworkStore(state => state.setNodeOwner);
export const useAddLinkByNodeId = () => useNetworkStore(state => state.addLinkByNodeId);
export const useDeleteLink = () => useNetworkStore(state => state.deleteLink);

// -------------------- Convenience actions --------------------

export const useAddDesignNode = () => {
    const addNode = useAddNode();
    return useCallback((payload: {x: number; y: number}) => {
        const nextId =
            Math.max(0, ...Object.keys(networkStore.getState().nodes).map(k => parseInt(k))) + 1;
        addNode({...payload, nodeId: nextId});
    }, [addNode]);
};
